import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";

class AddClip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            values: [],
            errors: {},
        };
    }

    createUI(props) {
        return this.state.values.map((el, i) =>
           <div>
                <div className="form-group" key={i}>
                    <div className="row" key={i}>
                        <div className="col-12 col-md-8"><input type="text" placeholder="Enter Clip" className="form-control" value={el || ''} onChange={this.handleChange.bind(this, i)} name={i}/></div>
                        {i == (this.state.values.length - 1) && <div className="col-12 col-md-4 addIcon"><i class="fa fa-plus" aria-hidden="true" title="Add Additional Clip" onClick={this.addClick.bind(this)}></i></div>}
                        {i !== (this.state.values.length - 1) && <div className="col-12 col-md-4 removeIcon"><i class="fa fa-minus" title="Remove Clip" aria-hidden="true" onClick={this.removeClick.bind(this, i)}></i></div>}
                    </div>
                </div>
            </div>
        )
    }

    handleChange(i, event) {
        let values = [...this.state.values];
        values[i] = event.target.value;
        this.setState({ values });
        this.props.onChange(values);
    }

    addClick() {
        this.setState(prevState => ({ values: [...prevState.values,''] }))
    }

    removeClick(i) {
        let values = [...this.state.values];
        values.splice(i, 1);
        this.setState({ values });
    }

    componentDidMount() {
        this.addClick();
    }

    render() {
        return (
            <Fragment>
                <label>Clip</label>
                {this.createUI()}
            </Fragment>
        );
    }
}

AddClip.contextType = AppContext;
export default AddClip;


// WEBPACK FOOTER //
// ./src/components/admin/writers/AddClip.js